/*
  C Home Sleep Study: the before -> after timeline bar (sections/c-home-sleep-study.liquid).

  The Figma "Timeline" component goes from its "Default" variant (grey bar) to "with apollo" (gradient bar).
  Here the bar starts grey and the gradient sweeps in once, when the bar scrolls into view. The CSS does the
  animation; this only arms the bar and flips it.

  The markup renders the end state. Nothing is armed without IntersectionObserver or with reduced motion,
  so those visitors (and no-JS ones) see the filled bar and never an empty one.
  A custom element, so it also initialises when the theme editor re-renders the section.
*/
(() => {
  const TAG = 'c-home-sleep-study-timeline';
  if (customElements.get(TAG)) return;

  customElements.define(
    TAG,
    class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-animate') || this.observer) return;
        if (!('IntersectionObserver' in window)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.classList.add('is-armed');
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.classList.add('is-filled');
            this.disconnectObserver();
          },
          { threshold: 0.6 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.disconnectObserver();
      }

      disconnectObserver() {
        if (!this.observer) return;
        this.observer.disconnect();
        this.observer = null;
      }
    }
  );
})();
